var _circle, _path, _circle2, _circle3, _path2, _circle4, _circle5, _path3, _circle6, _circle7, _circle8, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EFF0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 4.57031V9.14174",
    stroke: "#F32020",
    strokeWidth: 1.14286,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00014,
    cy: 10.8527,
    r: 0.571429,
    fill: "#F32020"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EFF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 4.57031V8.57031",
    stroke: "#F32020",
    strokeWidth: 1.14286,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00014,
    cy: 10.8527,
    r: 0.571429,
    fill: "#F32020"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F32020",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 4.57031V8.57031",
    stroke: "#F32020",
    strokeOpacity: 0.7,
    strokeWidth: 1.14286,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99983,
    cy: 10.7401,
    r: 0.685714,
    transform: "rotate(-180 7.99983 10.7401)",
    fill: "#F32020",
    fillOpacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EFF0F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#A4A6AD",
    strokeOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4907 5.136L8.00008 8.57031L7.50947 5.136C7.46682 4.83743 7.69849 4.57031 8.00008 4.57031C8.30168 4.57031 8.53335 4.83743 8.4907 5.136Z",
    fill: "#F32020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94354 5.21803L7.43416 8.65234L8.56553 8.65234L9.05615 5.21803C9.14798 4.57522 8.64918 4.0001 7.99984 4.0001C7.35051 4.0001 6.85171 4.57522 6.94354 5.21803Z",
    fill: "#F32020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85686 10.8571C6.85686 10.226 7.36854 9.71429 7.99972 9.71429C8.6309 9.71429 9.14258 10.226 9.14258 10.8571C9.14258 11.4883 8.6309 12 7.99972 12C7.36854 12 6.85686 11.4883 6.85686 10.8571Z",
    fill: "#F32020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.3d78447d.svg";
export { ForwardRef as ReactComponent };